import { useCallback } from 'react';

import { AnyComparator } from '../../types';
import { useConditionState } from './useConditionState';

export const useComparatorState = () => {
  const {
    condition: { comparatorType: comparator },
    setCondition,
  } = useConditionState();
  const setComparator = useCallback(
    (newComparator?: AnyComparator) =>
      setCondition((condition) => ({ ...condition, comparatorType: newComparator })),
    [setCondition],
  );
  return { comparator, setComparator };
};
